import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "converted-amount"
}

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConvertedAmount',
  props: {
    amountProp: {}
  },
  setup(__props: any) {

  const props = __props;

  const auctionStore = useAuctionStore();

  const currencies = computed(() => {
    return auctionStore.currencies;
  });

  const currency = computed(() => {
    return auctionStore.currency;
  });

  const convertedBid = computed(() => {
    let rate = currencies.value.find((item) => item.abbr === currency.value.calue).rate;

    return rate ? props.amountProp * rate : "~";
  });

return (_ctx: any,_cache: any) => {
  return (convertedBid.value > 0)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.formatCurrency(convertedBid.value, "")) + " " + _toDisplayString(currency.value), 1))
    : _createCommentVNode("", true)
}
}

})